import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ColumnTotalVisibility } from '@shared/utils/Table/TableColumn.interface';
import { useTableTotals } from '../Hooks/useTableTotals';
import { TableFooterCell } from './Cells/TableFooterCell';
export const TableFooterRow = ({ tableTotalsService, columns, groupColumn, columnsWidth, rows, subscribeTableUpdate }) => {
    const { formattedTotals } = useTableTotals(ColumnTotalVisibility.Overall, tableTotalsService, columns, rows, true, subscribeTableUpdate);
    const renderTableFooterCell = (column, isGroupColumn) => {
        var _a, _b;
        const id = 'total' + column.id;
        const formattedTotal = isGroupColumn ? '' : ((_a = formattedTotals.get(column.id)) !== null && _a !== void 0 ? _a : '');
        return (_jsx(TableFooterCell, { "data-testid": id, text: formattedTotal, alignment: column.alignment, width: (_b = columnsWidth.get(column.id)) !== null && _b !== void 0 ? _b : column.defaultWidth }, id));
    };
    return (_jsxs("tr", { className: "table-foot-row", children: [groupColumn !== null && renderTableFooterCell(groupColumn, true), columns.map((column) => {
                if (column === groupColumn) {
                    return null;
                }
                return renderTableFooterCell(column, false);
            })] }));
};
